import { Leaf, Phone, Mail, Heart } from "lucide-react";

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#2D2A26] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Leaf className="w-6 h-6 text-[#8F9E82]" />
              <span className="font-['Playfair_Display'] text-2xl">Benevolent Benefit</span>
            </div>
            <p className="text-stone-400 leading-relaxed mb-6">
              Compassionate end-of-life care and support for those transitioning 
              and their families. Because no one should face life's final journey alone.
            </p>
            <div className="flex items-center gap-2 text-[#8F9E82]">
              <Heart className="w-4 h-4" />
              <span className="text-sm">Serving with love and compassion</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <nav className="space-y-2">
              {[
                { label: "About", href: "#about" },
                { label: "Services", href: "#services" },
                { label: "Testimonials", href: "#testimonials" },
                { label: "Resources", href: "#blog" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-stone-400 hover:text-[#8F9E82] transition-colors text-left"
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Get in Touch</h4>
            <div className="space-y-4">
              <a 
                href="tel:504-374-8174" 
                className="flex items-center gap-3 text-stone-400 hover:text-[#8F9E82] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5" />
                <span>504-374-8174</span>
              </a>
              <a 
                href="mailto:inquiries@benevolentbenefit.me" 
                className="flex items-center gap-3 text-stone-400 hover:text-[#8F9E82] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
                <span>inquiries@benevolentbenefit.me</span>
              </a>
            </div>

            <div className="mt-6 p-4 bg-white/5 rounded-xl">
              <p className="text-xs text-stone-500 leading-relaxed">
                <strong className="text-stone-400">Privacy Notice:</strong> We respect your privacy. 
                All information shared is kept strictly confidential. We do not send unsolicited 
                emails or phone calls.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-stone-500">
            © {new Date().getFullYear()} Benevolent Benefit. All rights reserved.
          </p>
          <p className="text-sm text-stone-500">
            End of Life Doula & Companion Services
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
